import { render, staticRenderFns } from "./SocialNetworkEdit.vue?vue&type=template&id=c71cac5c&"
import script from "./SocialNetworkEdit.vue?vue&type=script&lang=js&"
export * from "./SocialNetworkEdit.vue?vue&type=script&lang=js&"
import style0 from "./SocialNetworkEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports